import { Navigate } from "react-router-dom";
import { usePlatformAuth } from "../../context/PlatformAuthContext";

export const PlatformRoute = ({ children }) => {
  const { isAuthenticated, loading } = usePlatformAuth();

  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/platform/login" replace />;

  return children;
};
